import { LocalizationProvider, DatePicker as MuiDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import type { Dayjs } from "dayjs";
import dayjs from "dayjs";
import { useCallback } from "react";

import { useDynamicFormatString, type FormatStrings } from "@skilitics/localization";

type Props = {
  value: Date | undefined;
  disabled?: boolean;
  onChange: (value: Date | undefined) => void;
  label: FormatStrings;
};

export const DatePicker = ({ value, onChange, label, disabled }: Props) => {
  const handleEndDateChange = useCallback(
    (date: Dayjs | null) => {
      onChange(date?.toDate());
    },
    [onChange],
  );

  const formatMessage = useDynamicFormatString();

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <MuiDatePicker
        label={formatMessage(label)}
        value={dayjs(value)}
        onChange={handleEndDateChange}
        disabled={disabled}
      />
    </LocalizationProvider>
  );
};
